import { WishlistFiltrationGroupType } from '@notino/shared/definitions/types';

import { useWishlistStore } from '@containers/WishList/store';

export const useGetSelectedFilterItems = () => {
  const filtration = useWishlistStore((x) => x.filtration);
  const selectedNavigationValues = useWishlistStore(
    (x) => x.selectedNavigationValues
  );

  return (groupType: WishlistFiltrationGroupType) =>
    filtration
      .find((x) => x.groupType === groupType)
      ?.items.filter((x) =>
        selectedNavigationValues.includes(x.navigationValue)
      );
};
